import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Table, Space, Radio, Tag } from 'antd';
import { remove, differenceBy, find } from 'lodash'; // 'find' será útil
import { API } from 'aws-amplify';
import '../../../../styles/Ubicaciones.css';

const { Search } = Input;

const Ubicaciones = ({
  ubicaciones,
  setUbicaciones,
}) => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); 

  const [searchValue, setSearchValue] = useState('');
  const [showLoadingData, setShowLoadingData] = useState(false);
  const [columns, setColumns] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [locations, setLocations] = useState([]);
  const [banderaTags, setBanderaTags] = useState(false);

  const fetchFilter = async () => {
    setShowLoadingData(true);
    try {
      const response = await API.graphql({
        query: `query MyQuery {
          getFiltersRedshift(input: { type_location: 1, query: "getLocation"}) {
            key
            description_filter
            type_filter
            value_filter
            id_statement
          }
        }`
      });
      const result = response.data.getFiltersRedshift.sort((a, b) => a.value_filter.localeCompare(b.value_filter));
      const newData = result.map(item => {
        const { id_statement, ...rest } = item;
        return rest;
      });
      setData(newData.length > 0 && newData[0].value_filter !== "Sin Datos" ? newData : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setShowLoadingData(false);
    }
  };

  useEffect(() => {
    fetchFilter();
  }, []);

  useEffect(() => {
    if (!data) {
      setFilteredData([]);
      return;
    }
    const lowercasedFilter = searchValue.toLowerCase();
    const result = data.filter(item =>
      item.value_filter.toLowerCase().includes(lowercasedFilter)
    );
    setFilteredData(result);
  }, [searchValue, data]);

  useEffect(() => {
    if (locations.length > 0) {
      setSelectedRowKeys(locations.map(item => item.key));
      setUbicaciones(locations);
    }
    if (locations.length === 0) {
      setSelectedRowKeys([]);
      if (banderaTags) {
        setBanderaTags(false);
        setUbicaciones([]);
      }
    }
  }, [locations]);

  useEffect(() => {
    if (data && ubicaciones.length === 0) {
      const updatedData = data.map(item => ({
        ...item,
        description_filter: 'estado_home',
      }));
      setData(updatedData);
    }
  }, [ubicaciones]);

  useEffect(() => {
    const diff = differenceBy(ubicaciones, locations, 'key');
    if (diff.length > 0) {
      setSelectedRowKeys(ubicaciones.map(item => item.key));
      setLocations(ubicaciones);
    }

    if (ubicaciones.length === 0) {
      setSelectedRowKeys([]);
      setBanderaTags(false);
      setLocations([]);
    }
  }, [ubicaciones]);

  useEffect(() => {
    const onChangeType = (recordKey, value) => {
      const dataTmp = [...data];
      const itemToUpdate = find(dataTmp, { key: recordKey });

      if (itemToUpdate) {
        itemToUpdate.description_filter =
          value === 'estado_home'
            ? 'estado_home'
            : value === 'estado_work'
              ? 'estado_work'
              : 'estado_all';
        setData(dataTmp);
      }
    };

    if (data) setColumns([
      {
        title: 'Name',
        dataIndex: 'value_filter',
        width: '250px',
      },
      {
        title: 'Description',
        dataIndex: 'description_filter',
        render: (text, record, index) => ( 
          <Row className="SubmenuRegularGA UbicacionesFilters">
            <Col span={24}>
              <Radio.Group
                options={[
                    { label: 'Domicilio', value: 'estado_home' },
                    { label: 'Trabajo', value: 'estado_work' },
                    { label: 'Ambos', value: 'estado_all' }
                ]}
                value={record.description_filter}
                onChange={({ target }) => onChangeType(record.key, target.value)}
              />
            </Col>
          </Row>
        )
      },
    ]);
  }, [data, filteredData]);

  const onSelectTable = (record, selected) => {
    if (!selected) {
      const newLocations = locations.filter(location => location.key !== record.key);
      setLocations(newLocations);
      setUbicaciones(newLocations);
    } else {
      setLocations([...locations, record]);
    }
  };

  return (
    <Row className="Ubicaciones">
      <Col span={16}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Search
            placeholder="Buscar"
            allowClear
            loading={showLoadingData}
            onChange={(e) => setSearchValue(e.target.value)}
            onSearch={setSearchValue}
          />
        </Space>
        {columns ?
          <Table
            className="tableComportamientos"
            rowSelection={{
              selectedRowKeys,
              onSelect: onSelectTable
            }}
            columns={columns}
            loading={showLoadingData}
            dataSource={filteredData} 
            pagination={false}
            rowKey='key'
            scroll={{ y: 290, }}
          /> :
          'Sin resultados...'
        }
      </Col>
      <Col className="ResultSearch" span={8}>
        {
          locations && locations.map(({ key, value_filter, description_filter }) => (
            <Tag
              key={key}
              className="TagsSelectFilters"
              closable
              onClose={() => {
                const newLocations = locations.filter(item => item.key !== key);
                setLocations(newLocations);
                setBanderaTags(true);
              }}
            >
              {description_filter === 'estado_home'
                ? 'Domicilio: '
                : description_filter === 'estado_work'
                  ? 'Trabajo: '
                  : 'Domicilio y Trabajo: '}
              {value_filter}
            </Tag>
          ))
        }
      </Col>
    </Row>
  );
};

export default Ubicaciones;